<template>
    <modal name="creator-sort" class="filter-modal creator-sort"
           :width="`100%`" :height="`auto`" :pivotY="0.5"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div>
            <div class="filter_modal_wrap">
                <div class="filter_modal_top">
                    <div class="filter_img sort_img"></div>
                    <div class="filter_name">{{ $t('sort') }}</div>
                    <div class="close_btn" @click="modalClose()"></div>
                </div>

                <div class="mt20  filter_modal_status">
                    <div class="radio_wrap block_wrap">
                        <div class="inline_block">
                            <el-radio-group v-model="sortOption"
                                            @change="sortChange(sortOption)">
                                <el-radio :label="'mb_item_update'">{{ $t('b_update') }}</el-radio>
                                <el-radio :label="'itemCnt'">{{ $t('b_item') }}</el-radio>
                                <el-radio :label="'likeCnt'">{{ $t('b_like') }}</el-radio>

                            </el-radio-group>
                        </div>
                    </div>
                </div>
                <div class="wrapper_bottom">
                    <button class="" @click="modalClose">{{ $t('apply2') }}</button>
                </div>

            </div>
        </div>

    </modal>
</template>

<script>
import util from "@/mixins/util";

export default {
    name: "CreatorSort",
    mixins: [],
    components: {},
    inject: [ 'setSort'],
    provide() {
        return {}
    },
    props: {
        modalLayout: '',
    },
    data() {
        return {
            sortData: {},
            sort: '',
            sortOption: 'created_at',
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        handlerBeforeOpen(event) {
            if(!util.isEmpty(event.params.sortData)) {
                this.sortData = event.params.sortData;
            }else{
                this.sortData = {};
            }
            this.setterSortDataInData()
        },
        handlerOpened() {
        },
        handlerBeforeClose() {
        },
        modalClose() {
            this.$modal.hide('creator-sort');
        },
        setterSortDataInData() {
            if(!util.isEmpty(this.sortData.key)) {
                this.sortOption = this.sortData.key;
            }
        },

        sortChange(data) {
            this.setSort(data, 'desc')
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
